import React from "react";

const CheckBox = ({ width, height, checked, onClick, ...rest }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      style={{ cursor: "pointer" }}
      {...rest}
    >
      <rect
        x="1.67188"
        y="1.66919"
        width="16.6667"
        height="16.6667"
        rx="2.17159"
        stroke="#333333"
        strokeWidth="1.5"
        fill={checked ? "#333333" : "none"}
      />
      {checked && (
        <path
          d="M7.22656 9.99935L9.3099 12.0827L12.7821 7.91602"
          stroke="white"
          strokeWidth="1.08579"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )}
    </svg>
  );
};

CheckBox.defaultProps = {
  width: 20,
  height: 20,
  checked: false, // Default to false
};

export default CheckBox;
